export { GolfPlayersTemplate } from './GolfPlayersTemplate';
export type {
  GolfPlayerConfig,
  GolfPlayersTemplateLabels,
  GolfPlayersTemplateProps,
} from './GolfPlayersTemplate.types';
